import catalogContexts from "@utils/constants/catalogContexts";

const mainIndex = process.env.NEXT_PUBLIC_ALGOLIA_MAIN_INDEX_V2;

export default function forceUserSizeFiltersOnUiState(uiState, userSizeFilters, context) {
  if (context === catalogContexts.userlist) return uiState;
  if (!userSizeFilters) return uiState;
  if (
    uiState[mainIndex].refinementList.sizes?.length > 0 ||
    uiState[mainIndex].refinementList.available_sizes?.length > 0
  ) {
    return uiState;
  }

  const newUiState = { ...uiState };
  const userSizeFiltersCopy = [...userSizeFilters];

  if (newUiState[mainIndex].refinementList.in_stock?.includes("false")) {
    newUiState[mainIndex].refinementList.sizes = userSizeFiltersCopy;
  } else {
    newUiState[mainIndex].refinementList.available_sizes = userSizeFiltersCopy;
  }

  return newUiState;
}
